export const NOT_GETLISTADO_START = "NOT_GETLISTADO_START";
export const NOT_GETLISTADO_COMPLETE = "NOT_GETLISTADO_COMPLETE";
export const NOT_GETIMG_COMPLETE = "NOT_GETIMG_COMPLETE";
export const NOT_GETLISTADOADMIN_START = "NOT_GETLISTADOADMIN_START";
export const NOT_GETLISTADADMIN_COMPLETE = "NOT_GETLISTADOADMIN_COMPLETE";
export const NOT_GETGRUPOS_COMPLETE = "NOT_GETGRUPOS_COMPLETE";
export const NOT_LOADING_COMPLETE = "NOT_LOADING_COMPLETE";
export const NOT_DOWNLOAD_START = "NOT_DOWNLOAD_START";
export const NOT_DELETE_START = "NOT_DELETE_START";
export const NOT_SAVE_START = "NOT_SAVE_START";
export const NOT_SENDPUB_START = "NOT_SENDPUB_START";
export const NOT_GETPUBLICACION_START = "NOT_GETPUBLICACION_START";
export const NOT_GETPUBLICACION_COMPLETE = "NOT_GETPUBLICACION_COMPLETE";
export const NOT_PRUEBA_START = "NOT_PRUEBA_START";
export const NOT_FINLLAMADA_START = "NOT_FINLLAMADA_START";

export const NOT_GETNTF_START = "NOT_GETNTF_START";
export const NOT_GETNTF_COMPLETE = "NOT_GETNTF_COMPLETE";
export const NOT_RESPONDERNTF_START = "NOT_RESPONDERNTF_START";

export const NSB_MENSAJE_ADD = "NSB_MENSAJE_ADD";
export const NSB_MENSAJE_REM = "NSB_MENSAJE_REM";

export const USR_LOGIN_START = "USR_LOGIN_START";
export const USR_LOGIN_COMPLETE = "USR_LOGIN_COMPLETE";
export const USR_SETUSER_START = "USR_SETUSER_START";
export const USR_LOGOUT_START = "USR_LOGOUT_START";
export const USR_LOGOUT_COMPLETE = "USR_LOGOUT_COMPLETE";
export const USR_CARGANDO_COMPLETE = "USR_CARGANDO_COMPLETE";
export const USR_ERROR_COMPLETE = "USR_ERROR_COMPLETE";
export const USR_GETFUNCIONES_COMPLETE = "USR_GETFUNCIONES_COMPLETE";

export const LDD_GETLISTA_START = "LDD_GETLISTA_START";
export const LDD_GETLISTA_COMPLETE = "LDD_GETLISTA_COMPLETE";

export const DJ_GETLISTADO_START = "DJ_GETLISTADO_START";
export const DJ_GETLISTADO_COMPLETE = "DJ_GETLISTADO_COMPLETE";
export const DJ_APROBARRECHAZAR_START = "DJ_APROBARRECHAZAR_START";

export const DC_GETLISTADO_START = "DC_GETLISTADO_START";
export const DC_GETLISTADO_COMPLETE = "DC_GETLISTADO_COMPLETE";
export const DC_SOLICITAR_START = "DC_SOLICITAR_START";
export const DC_GUARDAR_START = "DC_GUARDAR_START";
export const DC_CANCELAR_START = "DC_CANCELAR_START";

export const ANT_GETLISTADO_START = "ANT_GETLISTADO_START";
export const ANT_GETLISTADO_COMPLETE = "ANT_GETLISTADO_COMPLETE";
export const ANT_SOLICITAR_START = "ANT_SOLICITAR_START";

export const ELE_GETLISTADO_START = "ELE_GETLISTADO_START";
export const ELE_GETLISTADO_COMPLETE = "ELE_GETLISTADO_COMPLETE";
export const ELE_SOLICITAR_START = "ELE_SOLICITAR_START";
export const ELE_GETELEMENTOS_COMPLETE = "ELE_GETELEMENTOS_COMPLETE";
export const ELE_RECIBIR_START = "ELE_RECIBIR_START";

export const EQ_OBTENER_START = "EQ_OBTENER_START";
export const EQ_OBTENER_COMPLETE = "EQ_OBTENER_COMPLETE";

//Vehiculos
export const VLO_CARGANDO_COMPLETE = "VLO_CARGANDO_COMPLETE";
export const VLO_GETPOOL_START = "VLO_GETPOOL_START";
export const VLO_GETPOOL_COMPLETE = "VLO_GETPOOL_COMPLETE";
export const VLO_GETMOVILES_START = "VLO_GETMOVILES_START";
export const VLO_GETMOVILES_COMPLETE = "VLO_GETMOVILES_COMPLETE";
export const VLO_GETPROPERTIES_START = "VLO_GETPROPERTIES_START";
export const VLO_GETPROPERTIES_COMPLETE = "VLO_GETPROPERTIES_COMPLETE";
export const VLO_SETMOVIL_COMPLETE = "VLO_SETMOVIL_COMPLETE";
export const VLO_GETOPCIONES_COMPLETE = "VLO_GETOPCIONES_COMPLETE";
export const VLO_SETMIMOVIL_START = "VLO_SETMIMOVIL_START";
export const VLO_SETCENSO_START = "VLO_SETCENSO_START";
